import React, { Component } from "react";
import { BrowserRouter as Router, Redirect, Route } from "react-router-dom";
import Home from "./views/Home/home";
import Novedades from "./views/News/news";
import Finish from "./views/Finish/finish";
import Auditorias from "./views/Auditorias/auditorias";
import EditarFormulario from "./views/Auditorias/editarFormulario";
import Archivos from "./views/Files/files";
import Tickets from "./views/Tickets/tickets";

class App extends Component {
  state = {
    loggedIn: false
  };
  loginHandle = () => {
    this.setState(prevState => ({
      loggedIn: !prevState.loggedIn
    }));
  };

  render() {
    return (
      <Router>
        <div className="App">
          <Route
            path="/"
            exact
            strict
            render={() => {
              return <Home />;
            }}
          />
          <Route
            path="/finish"
            exact
            strict
            render={() => {
              return <Finish />;
            }}
          />
          <Route
            path="/novedades"
            exact
            strict
            render={() => {
              return <Novedades />;
            }}
          />
          <Route
            path="/auditorias"
            exact
            strict
            render={() => {
              return <Auditorias />;
            }}
          />
          <Route
            path="/editarFormulario"
            exact
            strict
            render={() => {
              return <EditarFormulario />;
            }}
          />
          <Route
            path="/archivos"
            exact
            strict
            render={() => {
              return <Archivos />;
            }}
          />
          <Route
            path="/tickets"
            exact
            strict
            render={() => {
              return <Tickets />;
            }}
          />
        </div>
      </Router>
    );
  }
}

export default App;
